import { useEffect, useState } from "react";
import { LayoutTemplate, Lightbulb, BookMarked, FilePlus2, X, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";

export function BailleurTemplate({ bailleur, docType, onInsert, onClose }) {
  const [tpl, setTpl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    api.get(`/projets/templates/${bailleur}`, { params: { doc_type: docType } })
      .then(({ data }) => alive && setTpl(data)).catch(() => alive && setTpl({ available: false })).finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [bailleur, docType]);

  return (
    <div className="mt-3 rounded-2xl border border-[#0E7C7B]/30 bg-[#0E7C7B]/5 p-5" data-testid="projets-template">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="flex items-center gap-2 font-semibold text-navy"><LayoutTemplate size={16} className="text-[#0E7C7B]" /> Modèle pré-rempli par bailleur</p>
          {tpl?.available && <p className="mt-0.5 text-xs text-slate-500">{tpl.bailleur} — {tpl.intitule}</p>}
        </div>
        <button onClick={onClose} className="text-slate-400 hover:text-navy" data-testid="projets-template-close"><X size={18} /></button>
      </div>
      {loading ? <Loader2 size={16} className="mt-3 animate-spin text-slate-400" /> : !tpl?.available ? (
        <p className="mt-3 text-sm text-slate-500" data-testid="projets-template-none">Aucun modèle spécifique pour ce bailleur : des modèles existent pour ONU / OCHA, Union Européenne et Banque Mondiale. L'IA appliquera néanmoins les standards généraux du bailleur sélectionné.</p>
      ) : (
        <div className="mt-3 grid gap-4 lg:grid-cols-[1fr_320px]">
          <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="projets-template-sections">
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Sections attendues</p>
            <pre className="mt-2 max-h-[360px] overflow-y-auto whitespace-pre-wrap font-sans text-xs leading-relaxed text-slate-700">{tpl.sections}</pre>
            <Button onClick={() => onInsert(tpl.sections)} data-testid="projets-template-insert" className="mt-3 rounded-full bg-[#0E7C7B] text-xs text-white hover:bg-[#0c6a69]"><FilePlus2 size={13} className="mr-1" /> Insérer la structure dans le document</Button>
            <p className="mt-1.5 text-[11px] text-slate-400">La structure est ajoutée à la fin de l'éditeur ; « Générer avec l'IA » et « Suggérer un plan » appliquent déjà ce modèle automatiquement.</p>
          </div>
          <div className="space-y-3">
            <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="projets-template-vocab">
              <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500"><BookMarked size={13} /> Vocabulaire du bailleur</p>
              <div className="mt-2 flex flex-wrap gap-1.5">{(tpl.vocabulaire || []).map((v) => <span key={v} className="rounded-full bg-slate-100 px-2 py-0.5 text-[11px] text-navy">{v}</span>)}</div>
            </div>
            <div className="rounded-xl border border-amber-200 bg-amber-50 p-4" data-testid="projets-template-tips">
              <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-amber-700"><Lightbulb size={13} /> Conseils</p>
              <ul className="mt-2 list-disc space-y-1 pl-4 text-xs text-slate-700">{(tpl.conseils || []).map((c, i) => <li key={i}>{c}</li>)}</ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
